import { useEffect, useState } from 'react';
import './PropertyGallery.css';

export default function PropertyGallery({ images, alt = 'Property interior' }) {
  const [active, setActive] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const count = images.length;
  const move = amount => setActive(index => (index + amount + count) % count);

  useEffect(() => {
    if (!lightboxOpen) return undefined;
    const onKeyDown = event => {
      if (event.key === 'Escape') setLightboxOpen(false);
      if (event.key === 'ArrowLeft') setActive(index => (index - 1 + count) % count);
      if (event.key === 'ArrowRight') setActive(index => (index + 1) % count);
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);
    return () => { document.body.style.overflow = previousOverflow; document.removeEventListener('keydown', onKeyDown); };
  }, [lightboxOpen, count]);

  function onKeyDown(event) {
    if (event.key === 'ArrowLeft') move(-1);
    if (event.key === 'ArrowRight') move(1);
  }

  return <div className="property-gallery" tabIndex={0} onKeyDown={onKeyDown} aria-label={`Property gallery, image ${active + 1} of ${count}`}>
    <button className="property-gallery__image-button" type="button" aria-label={`Open property image ${active + 1} in full screen`} onClick={() => setLightboxOpen(true)}><img className="property-gallery__image" src={images[active]} alt={`${alt}, view ${active + 1} of ${count}`} /></button>
    <button className="property-gallery__arrow property-gallery__arrow--previous" type="button" aria-label="Previous property image" onClick={() => move(-1)}>‹</button>
    <button className="property-gallery__arrow property-gallery__arrow--next" type="button" aria-label="Next property image" onClick={() => move(1)}>›</button>
    <div className="property-gallery__counter" aria-live="polite">{active + 1} / {count}</div>
    <div className="property-gallery__thumbs" aria-label="Choose property image">
      {images.map((image, index) => <button key={image} type="button" className={index === active ? 'is-active' : ''} aria-label={`Show property image ${index + 1}`} aria-current={index === active ? 'true' : undefined} onClick={() => setActive(index)}><img src={image} alt="" loading="lazy" /></button>)}
    </div>
    {lightboxOpen && <div className="property-gallery__lightbox" role="dialog" aria-modal="true" aria-label={`Property image ${active + 1} of ${count}`} onClick={event => { if (event.target === event.currentTarget) setLightboxOpen(false); }}>
      <button className="property-gallery__lightbox-close" type="button" aria-label="Close full screen image" onClick={() => setLightboxOpen(false)}>×</button>
      <button className="property-gallery__lightbox-arrow property-gallery__lightbox-arrow--previous" type="button" aria-label="Previous full screen image" onClick={() => move(-1)}>‹</button>
      <img className="property-gallery__lightbox-image" src={images[active]} alt={`${alt}, full screen view ${active + 1} of ${count}`} />
      <button className="property-gallery__lightbox-arrow property-gallery__lightbox-arrow--next" type="button" aria-label="Next full screen image" onClick={() => move(1)}>›</button>
      <div className="property-gallery__lightbox-thumbs" aria-label="Choose full screen image">{images.map((image, index) => <button key={image} type="button" className={index === active ? 'is-active' : ''} aria-label={`Show full screen image ${index + 1}`} onClick={() => setActive(index)}><img src={image} alt="" loading="lazy" /></button>)}</div>
    </div>}
  </div>;
}
